var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowMoreIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.28125C4.18359 0.28125 0.28125 4.18359 0.28125 9C0.28125 13.8164 4.18359 17.7188 9 17.7188C13.8164 17.7188 17.7188 13.8164 17.7188 9C17.7188 4.18359 13.8164 0.28125 9 0.28125ZM14.0625 9.98438C14.0625 10.2164 13.8727 10.4062 13.6406 10.4062H10.4062V13.6406C10.4062 13.8727 10.2164 14.0625 9.98438 14.0625H8.01562C7.78359 14.0625 7.59375 13.8727 7.59375 13.6406V10.4062H4.35938C4.12734 10.4062 3.9375 10.2164 3.9375 9.98438V8.01562C3.9375 7.78359 4.12734 7.59375 4.35938 7.59375H7.59375V4.35938C7.59375 4.12734 7.78359 3.9375 8.01562 3.9375H9.98438C10.2164 3.9375 10.4062 4.12734 10.4062 4.35938V7.59375H13.6406C13.8727 7.59375 14.0625 7.78359 14.0625 8.01562V9.98438Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreIconWhite);
export default __webpack_public_path__ + "static/media/show-more-icon-white.cf2ebf0811def5600fab0b9a0fb8e454.svg";
export { ForwardRef as ReactComponent };